import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sdmTime'
})
export class SdmTimePipe implements PipeTransform {

  transform(value: number): Date {
    if (value && value.toString().length === 6) {
      const dateTime = new Date();

      dateTime.setHours(
        parseInt(value.toString().substr(0, 2), 10),
        parseInt(value.toString().substr(2, 2), 10),
        parseInt(value.toString().substr(4, 2), 10)
      );

      return dateTime;

    } else if (value && value.toString().length === 5) {

      const dateTime = new Date();

      dateTime.setHours(
        parseInt(value.toString().substr(0, 1), 10),
        parseInt(value.toString().substr(1, 2), 10),
        parseInt(value.toString().substr(3, 2), 10)
      );
      return dateTime;
    }

    return null;
  }

}
